const imageMap = {
    '19" Tempest': 'rims-19-tempest',
    '19" Tempest Wheels': 'rims-19-tempest',
    '20" Cyberstream': 'rims-20-cyberstream',
    '20" Cyberstream Wheels': 'rims-20-cyberstream',
    '21" Arachnid': 'rims-21-arachnid',
    '21" Arachnid Wheels': 'rims-21-arachnid',
    '22" Turbine': 'rims-22-turbine',
    '22" Turbine Wheels': 'rims-22-turbine',
    '22" Onyx Black Turbine': 'rims-22-turbine',
    '22" Onyx Black Wheels': 'rims-22-turbine',
    '18" Aero rims': 'rims-aero',
    '18" Aero velgen': 'rims-aero-refresh',
    '18" Aero Wheels': 'rims-aero-refresh',
    '19" Sport rims': 'rims-sport-refresh',
    '19" Sport Wheels': 'rims-sport-refresh',
    '19" Sport velgen': 'rims-sport-refresh',
    '19’’ Gemini Wheels': 'rims-gemini',
    '20’’ Induction Wheels': 'rims-induction',
    '21’’ Überturbine Wheels': 'rims-uberturbine-21',
    '20’’ Überturbine Wheels': 'rims-uberturbine-20',
    '20’’ Warp Wheels': 'rims-20-warp',
    '18" Photon Wheels': 'rims-18-photon',
    "18'' Photon Wheels": 'rims-18-photon',
    '19" Nova Wheels': 'rims-19-nova',
    "19'' Nova Wheels": 'rims-19-nova',
}

const simpleNames = [
    '19-metallic',
    '19-silver',
    '19-slipstream',
    '19-tempest',
    '20-carbon',
    '20-metallic',
    '20-silver',
    '20-performance',
    '20-cyberstream',
    '21-carbon',
    '21-arachnid',
    '21-turbine',
    '22-turbine',
    'aero',
    'sport',
    'gemini',
    'induction',
    'uberturbine',
]

const onlyTextRegex = /[^a-z0-9]/g

function createImageKey(description) {
    return description.toLowerCase().replace(onlyTextRegex, '')
}

const normalizedImageMap = Object.keys(imageMap).reduce(
    (target, imageKey) => ({
        ...target,
        [createImageKey(imageKey)]: imageMap[imageKey],
    }),
    {}
)

export function getRimsImage(description) {
    const imageKey = createImageKey(description)
    let color = normalizedImageMap.hasOwnProperty(imageKey) ? normalizedImageMap[imageKey] : undefined

    // if exact match was not found, get the color by testing if a simple color name is in the string
    if (!color) {
        const simpleName = simpleNames.find(simpleName =>
            simpleName.split('-').every(simpleNamePart => simpleNamePart.indexOf(imageKey) > -1)
        )
        if (simpleName) {
            color = `rims-${simpleName}`
        }
    }
    return color ? `/assets/images/swatches/${color}.jpg` : null
}
